import type { GroupedLayer } from '../../map-editor-features/csv/lib/layerGrouper'

/** Subset of floor mapData for CSV read helpers (avoids circular import with floorStore). */
export type MapDataCsvShape = {
  csv?: {
    rawData?: string
    fileName?: string
    parsedData?: unknown
    groupedLayers?: GroupedLayer[] | null
    selectedLayers?: string[]
  } | null
  csvRawData?: string | null
  csvFileName?: string | null
  csvParsedData?: unknown
  csvGroupedLayers?: GroupedLayer[] | null
  csvSelectedLayers?: string[]
} | null | undefined

/** Reads CSV raw text from migrated `mapData.csv` or legacy flat fields. */
export function mapDataGetCsvRaw(mapData: MapDataCsvShape): string | null {
  if (!mapData) return null
  if (mapData.csv?.rawData) return mapData.csv.rawData
  return mapData.csvRawData ?? null
}

export function mapDataGetCsvFileName(mapData: MapDataCsvShape): string | null {
  if (!mapData) return null
  if (mapData.csv?.fileName) return mapData.csv.fileName
  return mapData.csvFileName ?? null
}

export function mapDataGetCsvParsed(mapData: MapDataCsvShape): unknown | null {
  if (!mapData) return null
  if (mapData.csv?.parsedData != null) return mapData.csv.parsedData
  return mapData.csvParsedData ?? null
}

export function mapDataGetCsvGroupedLayers(mapData: MapDataCsvShape): GroupedLayer[] | null {
  if (!mapData) return null
  if (mapData.csv?.groupedLayers != null) return mapData.csv.groupedLayers ?? null
  return mapData.csvGroupedLayers ?? null
}

export function mapDataGetCsvSelectedLayers(mapData: MapDataCsvShape): string[] {
  if (!mapData) return []
  if (mapData.csv?.selectedLayers?.length) return mapData.csv.selectedLayers
  return mapData.csvSelectedLayers ?? []
}
